<template>
  <div class="order_code">
    <div class="codePayContainer" v-show="payParams.wxCodeVisible">
      <div v-show="payParams.wxCodeVisible">
        <p style="text-align: center">
          {{payParams.payInfo}}
        </p>
        <qr-code :qr-code-params="payParams.wxParams" v-if="payParams.wxCodeVisible"></qr-code>
      </div>
    </div>
  </div>
</template>

<script>

import QrCode from "@/components/PayQrCode/wxPayQrCode";
export default {
  name: "OrderCode",
  components: {QrCode},
  props: {
    payParams: Object
  },
  data() {
    return {

    }
  },
  methods: {
    handleBalancePayClick() {
      this.$emit("balance-pay-click")
    }
  }
}
</script>

<style lang="less">
.order_code {

  .codePayContainer {
    text-align: center;
  }

  .codePayContainer .dbCodePay {
    margin: 10px auto;
    width: 256px;
    height: 256px;
  }

  .codePayContainer .dbCodePay img {
    width: 256px;
    height: 256px;
  }

  .codePayContainer .balancePay .el-input {
    max-width: 350px;
  }

  .codePayContainer .el-input-group__append, .el-input-group__prepend {
    background-color: #245069;
    color: #fff;
    font-size: 16px;
    border: solid 1px #245069;
  }
  .payPassword {
    position: relative;
    margin: 20px auto 0;
  }
  .thumb-btn {
    height: 40px!important;
    width: 77px;
  }

}
</style>